import * as React from 'react';
import { CustomForm, CustomFormReportData } from '../../../../../amorg-common';

import { Button, ButtonProps } from '../../../../../designSystem/button/Button';
import { AnimatedCollapsibleContent } from '../../../../../designSystem/collapsible/AnimatedCollapsibleContent';
import { Flex } from '../../../../../designSystem/compositeComponents/FlexHelpers';
import { SelectField } from '../../../../../designSystem/formField/SelectField';
import { CustomFormFilter } from '../../../../../utils/customFormHelper';

type CustomFormFiltersPanelProps = {
    form:CustomForm,
    report:CustomFormReportData,
    filter:CustomFormFilter[],
    buttons?:ButtonProps[],
    onFilterChange:(fieldId:string, value:string) => void
}
export function CustomFormFiltersPanel(props:CustomFormFiltersPanelProps):JSX.Element
{
    const [showFilters, setShowFilters] = React.useState(false);

    function handleSelectionChanged(fieldId:string, value:string)
    {
        props.onFilterChange(fieldId, value);
    }

    return (
        <section style={{ marginTop: '24px' }}>
            <Flex justifyContent='flex-end' gap={8}>
                {props.buttons?.map((button, index) => 
                    <Button key={index} {...button} />
                )}
                <Button variant="outlined" onClick={() => setShowFilters(!showFilters)} text="Filtre"
                    icon={showFilters ? 'caret_caretUp' : 'caret_caretDown'} />
            </Flex>
            <AnimatedCollapsibleContent open={showFilters}>
                {props.filter.map((filter) => 
                    <SegmentFilter
                        filter={filter}
                        key={filter.fieldId}
                        onSelectionChanged={(v) => { handleSelectionChanged(props.form.fields.find(f => f.fieldId === filter.fieldId)?.fieldId || '', v)}}
                    />
                )}
            </AnimatedCollapsibleContent>
        </section>
    );
}

type SegmentFilterProps = {
    filter:CustomFormFilter,
    onSelectionChanged:(v:string) => void
}
function SegmentFilter(props:SegmentFilterProps):JSX.Element
{
    return (
        <SelectField
            label={props.filter.label}
            options={[
                { text:'Alle', value:'' },
                ...props.filter.values.map(v => ({ text:v.label, value:v.val }))
            ]}
            selectedValue={props.filter.selectedValue}
            onChange={props.onSelectionChanged}
        />
    );
}